<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import LaisCard from 'dashboard/components-next/LaisCard.vue';
import LaisPrimaryButton from 'dashboard/components-next/LaisPrimaryButton.vue';

const props = defineProps({
  item: { type: Object, required: true },
  index: { type: Number, required: true },
  editable: { type: Boolean, default: false },
  participants: { type: Array, default: () => [] },
});
const emit = defineEmits(['remove', 'open']);
const { t } = useI18n();
const labels = computed(() => ({
  imovel: t('SALES.REVIEW.SECTIONS.PROPERTY'),
  recibo: t('SALES.REVIEW.SECTIONS.RECEIPT'),
  vendedor_pf: t('SALES.REVIEW.SECTIONS.SELLER_PF'),
  vendedor_pj: t('SALES.REVIEW.SECTIONS.SELLER_PJ'),
  comprador_pf: t('SALES.REVIEW.SECTIONS.BUYER_PF'),
  comprador_pj: t('SALES.REVIEW.SECTIONS.BUYER_PJ'),
}));
const sectionLabel = computed(
  () => labels.value[props.item.section] || props.item.section
);
const targetName = computed(() => {
  const target = props.participants.find(
    party => String(party.id) === String(props.item.target_key)
  );
  return props.item.target_name || target?.name || props.item.target_key;
});
</script>

<template>
  <LaisCard :title="sectionLabel" prefix-icon="i-lucide-triangle-alert">
    <div class="grid gap-3">
      <div class="flex flex-wrap items-center justify-between gap-2">
        <span
          class="rounded-full bg-red-50 px-2 py-1 text-xs font-bold text-red-700"
        >
          {{
            item.status === 'corrigido'
              ? t('SALES.REVIEW.STATUS.CORRECTED')
              : t('SALES.REVIEW.STATUS.PENDING')
          }}
        </span>
        <span v-if="targetName" class="text-xs text-lais-text-muted">
          {{ targetName }}
        </span>
      </div>
      <ul class="list-disc pl-5 text-sm text-lais-text-body">
        <li
          v-for="(check, checkIndex) in item.checks || []"
          :key="check.id || checkIndex"
        >
          {{ check.name || check.nome || check }}
        </li>
      </ul>
      <p class="text-sm text-lais-text-body">{{ item.observation }}</p>
      <div class="flex flex-wrap justify-end gap-2">
        <LaisPrimaryButton
          v-if="item.section !== 'recibo'"
          variant="ghost"
          size="sm"
          icon="i-lucide-pencil"
          @click="emit('open', item)"
        >
          {{ t('SALES.REVIEW.ACTIONS.OPEN') }}
        </LaisPrimaryButton>
        <LaisPrimaryButton
          v-if="editable"
          variant="ghost"
          size="sm"
          icon="i-lucide-trash-2"
          @click="emit('remove', index)"
        >
          {{ t('SALES.REVIEW.ACTIONS.REMOVE') }}
        </LaisPrimaryButton>
      </div>
    </div>
  </LaisCard>
</template>
